export default __webpack_public_path__ + "static/media/Glove2.a37398e6.svg";